const EXAMPLE_BARCODE_ACTION = 'EXAMPLE_BARCODE_ACTION';

export const exampleBarcodeAction = (barcode) => ({
  type: EXAMPLE_BARCODE_ACTION,
  payload: barcode
});
